import * as Yup from 'yup';

import {
  HIRAGANA_REGEXP,
  NAME_KANA_MAX_LENGTH,
  NAME_MAX_LENGTH,
  ORGANIZATION_MEMBERSHIP_CODE_REGEXP,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_REGEXP,
  ZENKAKU_REGEXP,
} from 'interfaces/registration';
import { HANKAKU_REGEXP, SAPURI_EMAIL_REGEXP } from 'store/constants';

export const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('パスワードは必須です')
    .test(
      'min',
      `パスワードは${PASSWORD_MIN_LENGTH}文字以上で入力してください`,
      (value) =>
        value ? value.length <= 0 || value.length >= PASSWORD_MIN_LENGTH : true,
    )
    .max(
      PASSWORD_MAX_LENGTH,
      `パスワードは${PASSWORD_MAX_LENGTH}文字以内で入力してください`,
    )
    .matches(PASSWORD_REGEXP, {
      message:
        'パスワードは半角アルファベットと半角数字をそれぞれ1文字以上で入力してください',
      excludeEmptyString: true,
    })
    .test(
      'not-same-as-email',
      'メールアドレスとパスワードに同じ文字列は使用できません',
      function (value) {
        const { email } = this.parent;
        // emailとpasswordの両方が空でない場合のみチェック
        if (
          !value ||
          !email ||
          (typeof value === 'string' && value.trim() === '') ||
          (typeof email === 'string' && email.trim() === '')
        ) {
          return true;
        }
        return value !== email;
      },
    ),
  password_confirmation: Yup.string()
    .required('パスワード（確認用）は必須です')
    .oneOf([Yup.ref('password')], 'パスワードが一致しません'),
  last_name: Yup.string()
    .trim()
    .required('姓は必須です')
    .matches(ZENKAKU_REGEXP, {
      message: '姓は全角文字で入力してください',
      excludeEmptyString: true,
    })
    .max(NAME_MAX_LENGTH, `姓は${NAME_MAX_LENGTH}文字以内で入力してください`),
  first_name: Yup.string()
    .trim()
    .required('名は必須です')
    .matches(ZENKAKU_REGEXP, {
      message: '名は全角文字で入力してください',
      excludeEmptyString: true,
    })
    .max(NAME_MAX_LENGTH, `名は${NAME_MAX_LENGTH}文字以内で入力してください`),
  last_name_kana: Yup.string()
    .required('姓（かな）は必須です')
    .matches(HIRAGANA_REGEXP, {
      message: '姓（かな）はひらがなで入力してください',
      excludeEmptyString: true,
    })
    .max(
      NAME_KANA_MAX_LENGTH,
      `姓（かな）は${NAME_KANA_MAX_LENGTH}文字以内で入力してください`,
    ),
  first_name_kana: Yup.string()
    .required('名（かな）は必須です')
    .matches(HIRAGANA_REGEXP, {
      message: '名（かな）はひらがなで入力してください',
      excludeEmptyString: true,
    })
    .max(
      NAME_KANA_MAX_LENGTH,
      `名（かな）は${NAME_KANA_MAX_LENGTH}文字以内で入力してください`,
    ),
  email: Yup.string()
    .required('メールアドレスは必須です')
    .matches(SAPURI_EMAIL_REGEXP, {
      message: 'メールアドレスの形式が不正です',
      excludeEmptyString: true,
    })
    .test(
      'should-not-end-with-a-dot',
      'メールアドレスの形式が不正です',
      (value) => !/\.$/.test(value),
    )
    .matches(HANKAKU_REGEXP, {
      message: 'メールアドレスは半角英数字で入力してください',
      excludeEmptyString: true,
    }),
  code: Yup.string()
    .required('団体会員コードは必須です')
    .matches(ORGANIZATION_MEMBERSHIP_CODE_REGEXP, {
      message: '団体会員コードは20桁までの半角数字で入力してください',
      excludeEmptyString: true,
    }),
});
